import { createContext, useContext, useState, useEffect, useRef } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem("token");
    return token ? { token } : null;
  });
  const intervalRef = useRef(null);

  const startSessionCheck = () => {
  if (intervalRef.current) clearInterval(intervalRef.current);
  intervalRef.current = setInterval(async () => {
    const token = localStorage.getItem("token");
    if (!token) return;

    // Do not check session when offline
    if (!navigator.onLine) return;

    try {
      const res = await fetch(
        "https://stocksense-backend-g1kp.onrender.com/auth/session/check",
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      // If response is not ok skip — likely server waking up
      if (!res.ok) return;

      const data = await res.json();

      // If service worker returned offline error skip
      if (data.error === "offline") return;

      if (data.valid === false) {
  clearInterval(intervalRef.current);
  localStorage.clear();
  setUser(null);
  localStorage.setItem(
    "logout_reason",
    data.reason || "You have been logged out because your account was accessed on another device."
  );
  window.location.href = "/login";
}
    } catch {
      // Network error — do not log out
    }
  }, 30000);
};

  useEffect(() => {
    if (user) {
      startSessionCheck();
    }
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [user]);

  const login = (data) => {
    localStorage.setItem("token", data.access_token);
    localStorage.setItem("user_name", data.full_name || data.business_name || "User");
    localStorage.setItem("user_role", data.role || "admin");
    localStorage.setItem("business_id", data.business_id);
    setUser({ token: data.access_token });
  };

  const logout = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    localStorage.clear();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}